import { types } from "../constants/types";
// reducers/postReducer.js
const initialState = {
  profile: {},
  holidayList:[],
  salaryData:{},
  salaryDetails:[],
  reminder:[],
  empLeaveRequestData:[],
  allInvoice:[],
  assignAssets:[],
  customerData:[],
  loading: false,
  error: null,
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EMPLOYEEPROFILE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_EMPLOYEEPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload,
      };
    case types.GET_EMPLOYEEPROFILE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.GET_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        holidayList: action.payload,
      };
    case types.GET_HOLIDAY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

   
    case types.GET_REMINDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_REMINDER_SUCCESS:
      return {
        ...state,
        loading: false,
        reminder: action.payload,
      };
    case types.GET_REMINDER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case types.GET_SALARY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_SALARY_SUCCESS:
      return {
        ...state,
        loading: false,
        salaryData: action.payload,
      };
    case types.GET_SALARY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

   
    case types.GET_EMPSALARYDATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_EMPSALARYDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        salaryDetails: action.payload,
      };
    case types.GET_EMPSALARYDATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

   
    case types.GET_EMP_LEAVEREQUEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_EMP_LEAVEREQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        empLeaveRequestData: action.payload,
      };
    case types.GET_EMP_LEAVEREQUEST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case types.GET_ALL_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ALL_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        allInvoice: action.payload,
      };
    case types.GET_ALL_INVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case types.GET_ASSIGN_ASSET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ASSIGN_ASSET_SUCCESS:
      return {
        ...state,
        loading: false,
        assignAssets: action.payload,
      };
    case types.GET_ASSIGN_ASSET_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      case types.GET_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_CUSTOMER_SUCCESS:
   
      return {
        ...state,
        loading: false,
        customerData: action.payload,
      };
    case types.GET_CUSTOMER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

   


    default:
      return state;
  }
};

export default employeeReducer;
